import React from "react";
import "primeicons/primeicons.css"; 
import "primeflex/primeflex.css"; 
import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import 'primeicons/primeicons.css';
import "./App.css";
import "@fontsource/roboto";
import BaseLayout from "./components/layout/baseLayout/BaseLayout";
import Login from "./pages/regular/login/Login";
import Register from "./pages/regular/register/Register";
import Home from "./pages/regular/home/Home";
import Dashboard from "./pages/regular/dashboard/Dashboard";
import ForgotPassword from "./pages/regular/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/regular/resetPassword/ResetPassword";
import ErrorPage from "./pages/regular/errorPage/ErrorPage";
import PricesAndLiquidity from "./pages/regular/dashboards/PricesAndLiquidity/PricesAndLiquidity";




function App() {
  const routeDefinitions = createRoutesFromElements(
    <Route>
      <Route path="*" element={<ErrorPage />} />

      <Route
        path="/"
        element={<BaseLayout />}
        children={[
          <Route key="login" path="/login" element={<Login />} />,
          <Route key="register" path="/register" element={<Register />} />,
          <Route key="home" path="/" element={<Home />} />,
          <Route key="dashboard" path="/dashboard/:dashid" element={<Dashboard />} />,
          <Route key="forgot-password" path="/forgot-password" element={<ForgotPassword />} />,
          <Route key="reset-password" path="/reset-password/:token" element={<ResetPassword />} />,
          <Route key="prices-and-liquid" path="/prices-and-liquidity" element={<PricesAndLiquidity />} />
        ]}
      />
    </Route>
  );
  const router = createBrowserRouter(routeDefinitions);

  return <RouterProvider router={router} />;
}
export default App;
